
export const isNullOrUndefined = (obj) => {
    return typeof(obj) === "undefined" || obj === null || obj === 'null';
}

export const isEmpty = (obj) => {
    return obj == null || obj === 'null' || typeof(obj) === "undefined" || obj === "undefined"  || obj === "";
}

export const isNumber = (value) => {
    return !isEmpty(value) && typeof value === 'number' && isFinite(value);
}